import React, {useEffect, useState} from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import useOutsideClickHandler from "hooks/useOutsideClickHandler";
import './index.css';

type Dropdown3Props = {
    children?: React.ReactNode;
    className?: string;
    icon?: React.ReactNode;
    data: any[]; 
    selectedItems: any[];
    dataKey?: string;
    onSelect: (value: any) => void;
    placeholder?: string;
    required?: boolean;
    value?: any;
    disabled?: boolean;
    isOpen: boolean;
    setIsOpen?: (value: any) => void;
}

function Dropdown3 ({
    children,
    className,
    icon,
    data,
    selectedItems,
    dataKey,
    onSelect,
    placeholder,
    value,
    disabled,
    isOpen, 
    setIsOpen
}: Dropdown3Props) {
    const ref = useOutsideClickHandler(()=> setIsOpen && setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
    }

    return (
        <div
            className={isOpen
                ? `dropdown3--open ${className}`
                : disabled
                ? 'dropdown3--disabled'
                : `dropdown3 ${className}`
            }
            ref={ref}
        >
            <div 
                className={isOpen
                    ? "dropdown3__value--selected"
                    : "dropdown3__value" 
                }
                onClick={() => {
                    if (!disabled) setIsOpen(!isOpen);
                }}
            >
                <div className="dropdown3__valueContent" >
                    {icon}
                    {value
                        ?   <p>{value}</p>
                        :   placeholder
                        ?   <p className="dropdown3__placeholder">
                            {placeholder}
                            </p>
                        :   ''
                    }
                </div>
                {isOpen &&
                    <div className="dropdown3__items">
                        {data.map((item, i) => (
                            <div className="dropdown3__itemContainer" onClick={()=> selectItem(item)}>
                                <div className="dropdown3__checkIcon">
                                    {selectedItems.includes(item) && <FaCheck />}
                                </div>
                                <p
                                    key={i}
                                    className='dropdown3__item'
                                >
                                    {dataKey ? item[dataKey] : item}
                                </p>
                            </div>
                        ))}
                    </div>
                }
                {isOpen
                    ? <MdArrowDropUp className={isOpen? 'dropdown3__icon--selected':'dropdown3__icon'} />
                    : <MdArrowDropDown className='dropdown3__icon' />
                }
            </div>
        </div>
    )
}

export default Dropdown3;